// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 587) return "static/chunks/243f8a5c-ef8b22aecbfb6c90.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 675 ? "87f43a27" : chunkId) + "." + {"3":"0af4f7424f0385d5","122":"d804a349ef3d094b","281":"cb2fbe214f7a460e","324":"82d23662338b2f1b","368":"8ea2eedcb1e0c03c","649":"83537dfa1e579b2a","675":"33ebe5e5dd4ea20a","735":"f84b365e9f4dd7bf","943":"11b064f6dae9da0b"}[chunkId] + ".js";
};